export interface IHomeState {
    loading: boolean
    content: IHomeStaticInformation
}

export interface IHomeStaticInformation {
    slogan_en: string
    slogan_mk: string
    slogan_al: string
    carousel: IHomeCarousel[]
    why_genie: IHomeWhyGenie[]
    steps: IHomeSteps[]

    [key: string]: any
}

export interface IHomeCarousel {
    text_en: string
    text_mk: string
    text_al: string
    image: string
    link: string

    [key: string]: any
}

export interface IHomeSteps {
    label_en: string
    label_mk: string
    label_al: string

    [key: string]: any
}

export interface IHomeWhyGenie {
    title_en: string
    title_mk: string
    title_al: string
    subtitle_en: string
    subtitle_mk: string
    subtitle_al: string
    icon: string

    [key: string]: any
}

export const initialHomeStaticInformationState: IHomeStaticInformation = {
    slogan_en: "",
    slogan_mk: "",
    slogan_al: "",
    carousel: [],
    why_genie: [],
    steps: [],
}

export const getRandomWhyGenieArray = (): IHomeWhyGenie[] => {
    const arr: IHomeWhyGenie[] = []
    for (let i = 0; i < 4; i++) {
        arr.push(
            {
                title_mk: i.toString(), title_en: i.toString(), title_al: i.toString(),
                subtitle_mk: "", subtitle_en: "", subtitle_al: "", icon: ""
            }
        )
    }

    return arr
}